import React from "react";
import PropTypes from "prop-types";
import styles from "./styles";
import LuvitComponent from "LuvitComponent";
import { Clear as ClearIcon } from "Components/Icons";

class LuvitSkyLight extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Common");

    this.state = { isVisible: false, useProps: "isVisible" in this.props };
  }

  componentWillUpdate(nextProps, nextState) {
    let next = nextState,
      prev = this.state;
    if (this.state.useProps) {
      next = nextProps;
      prev = this.props;
    }

    if (next.isVisible && !prev.isVisible && this.props.beforeOpen) {
      this.props.beforeOpen();
    }

    if (!next.isVisible && prev.isVisible && this.props.beforeClose) {
      this.props.beforeClose();
    }
  }

  componentWillUnmount() {
    document.querySelector("html").style.overflowY = "auto";
  }

  componentDidUpdate(prevProps, prevState) {
    let next = this.state,
      prev = prevState;
    if (this.state.useProps) {
      next = this.props;
      prev = prevProps;
    }

    if (!prev.isVisible && next.isVisible && this.props.afterOpen) {
      this.props.afterOpen();
    }

    if (prev.isVisible && !next.isVisible && this.props.afterClose) {
      this.props.afterClose();
    }
  }

  show() {
    this.setState({ isVisible: true });
  }

  hide() {
    this.setState({ isVisible: false });
    document.querySelector("html").style.overflowY = "auto";
  }

  onOverlayClicked() {
    if (this.props.hideOnOverlayClicked) {
      this.hide();
      if (this.props.onOverlayClicked) {
        this.props.onOverlayClicked();
      }
    }

    if (this.props.onOverlayClicked) {
      this.props.onOverlayClicked();
    }
  }

  doRender() {
    let state = this.state.useProps ? this.props : this.state;
    var overlay;

    var dialogStyles = {};

    if (matchMedia) {
      if (window.matchMedia("( max-width:768px)").matches) {
        dialogStyles = {
          position: "fixed",
          height: "auto",
          minHeight: "100vh",
          margin: 0,
          top: "0px",
          top: "0px",
          overflowY: "auto",
          movable: false,
          zIndex: 1001,
        };
      } else {
        dialogStyles = Object.assign(
          {},
          styles.dialogStyles,
          this.props.dialogStyles,
        );
      }
    }

    var overlayStyles = Object.assign(
      {},
      styles.overlayStyles,
      this.props.overlayStyles,
    );
    var closeButtonStyle = Object.assign(
      {},
      styles.closeButtonStyle,
      this.props.closeButtonStyle,
    );
    var titleStyle = Object.assign({}, styles.title, this.props.titleStyle);

    if (state.isVisible) {
      overlayStyles.display = "block";
      dialogStyles.display = "block";
      !this.props.keepWindowScroll &&
        (document.querySelector("html").style.overflowY = "hidden");
    } else {
      overlayStyles.display = "none";
      dialogStyles.display = "none";
      !this.props.keepWindowScroll &&
        (document.querySelector("html").style.overflowY = "auto");
    }

    if (this.props.showOverlay) {
      overlay = (
        <div
          onClick={() => this.onOverlayClicked()}
          style={overlayStyles}
          className="modal-overlay"
        ></div>
      );
      var win = luvit.getLuvitTopPage();
    }

    var icon = <span className="hidden"></span>;

    if (this.props.type) {
      icon = <span className={"icon-" + this.props.type}></span>;
    }

    if (this.props.overflowVisible) {
      dialogStyles.overflowY = "visible";
    }

    return (
      <section className="modal-wrapper">
        {overlay}
        <div style={dialogStyles} className="modal animated fadeInDown">
          <button
            autoFocus
            onClick={() => this.hide()}
            role="button"
            title={this.l("close")}
            style={closeButtonStyle}
            className="button-transparent modal-close"
          >
            <span className="sr-only">{this.l("close")}</span>
            <div className="flex flex-center" aria-hidden="true">
              {<ClearIcon />}
            </div>
          </button>
          {this.props.title && (
            <h2 style={titleStyle}>
              {icon} {this.props.title}
            </h2>
          )}
          {this.props.children}
        </div>
      </section>
    );
  }
}

LuvitSkyLight.displayName = "LuvitSkyLight";

LuvitSkyLight.propTypes = {
  afterClose: PropTypes.func,
  afterOpen: PropTypes.func,
  beforeClose: PropTypes.func,
  beforeOpen: PropTypes.func,
  closeButtonStyle: PropTypes.object,
  dialogStyles: PropTypes.object,
  hideOnOverlayClicked: PropTypes.bool,
  onOverlayClicked: PropTypes.func,
  overlayStyles: PropTypes.object,
  showOverlay: PropTypes.bool,
  title: PropTypes.string,
  titleStyle: PropTypes.object,
};

LuvitSkyLight.defaultProps = {
  title: "",
  showOverlay: true,
  overlayStyles: styles.overlayStyles,
  dialogStyles: styles.dialogStyles,
  closeButtonStyle: styles.closeButtonStyle,
  hideOnOverlayClicked: false,
};

export default LuvitSkyLight;
